<script setup>
import Icon from '@/components/shared/icons/Icon.vue'

//Emits and props
defineEmits([
  'click',
  'close',
])
defineProps({
  type: {
    type: String,
    default: 'info',
  },
  text: {
    type: String,
    default: '',
  },
  isStatic: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    :class="{
      [$style.message]: true,
      [$style[type]]: !!type
    }"
    role="alert"
    @click="$emit('click', $event)"
  >
    <div :class="$style.text">
      <slot>{{ text }}</slot>
    </div>
    <slot name="action" />
    <Icon
      v-if="isStatic"
      icon="close"
      size="m"
      :class="$style.close"
      is-clickable
      @click="$emit('close', $event)"
    />
  </div>
</template>

<style module lang="scss">
.message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: var(--flash-message-height);
  max-width: 100%;
  padding: 1rem;
  border: 2px solid var(--color-borders);
  border-radius: var(--border-radius-m);
  box-shadow: var(--box-shadow);
  pointer-events: auto;
  &.success {
    border-color: var(--color-borders-success);
    background-color: var(--bg-status-success);
    color: var(--color-text-success);
  }
  &.warning {
    border-color: var(--color-borders-warning);
    background-color: var(--bg-status-warning);
    color: var(--color-text-warning);
  }
  &.danger {
    border-color: var(--color-borders-danger);
    background-color: var(--bg-status-danger);
    color: var(--color-text-danger);
  }
  &.info {
    border-color: var(--color-borders-info);
    background-color: var(--bg-status-info);
    color: var(--color-text-info);
  }
}
.text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.close {
  padding: 0.5rem;
  margin: -0.5rem;
}
</style>
